export default __webpack_public_path__ + "static/media/copy-gold.276706e5.svg";